import { ClerkProvider, SignIn, SignUp, useAuth } from "@clerk/react";
import { publishableKeyFromHost } from "@clerk/react/internal";
import { useLocation } from "wouter";
import App from "./App";
import { StandaloneAccessProvider } from "@/framework/microapp-context";

const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");
const clerkPubKey = publishableKeyFromHost(
  window.location.hostname,
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
);
const clerkProxyUrl = import.meta.env.VITE_CLERK_PROXY_URL;

function StandaloneContent() {
  const [location] = useLocation();
  const { isLoaded, isSignedIn } = useAuth();
  if (location.startsWith("/sign-in")) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <SignIn
          routing="path"
          path={`${basePath}/sign-in`}
          signUpUrl={`${basePath}/sign-up`}
        />
      </div>
    );
  }
  if (location.startsWith("/sign-up")) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <SignUp
          routing="path"
          path={`${basePath}/sign-up`}
          signInUrl={`${basePath}/sign-in`}
        />
      </div>
    );
  }
  return (
    <StandaloneAccessProvider authenticated={Boolean(isLoaded && isSignedIn)}>
      <App />
    </StandaloneAccessProvider>
  );
}

export default function StandaloneApp() {
  const [, setLocation] = useLocation();
  const stripBase = (path: string) =>
    basePath && path.startsWith(basePath)
      ? path.slice(basePath.length) || "/"
      : path;
  return (
    <ClerkProvider
      publishableKey={clerkPubKey}
      proxyUrl={clerkProxyUrl}
      signInUrl={`${basePath}/sign-in`}
      signUpUrl={`${basePath}/sign-up`}
      routerPush={(to) => setLocation(stripBase(to))}
      routerReplace={(to) => setLocation(stripBase(to), { replace: true })}
    >
      <StandaloneContent />
    </ClerkProvider>
  );
}